import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const MainPage = React.lazy(() => import('../containers/mainPage/MainPage'));
const MenuPage = React.lazy(() => import('../containers/menuPage/MenuPage'));
const CartPage = React.lazy(() => import('../containers/cartPage/CartPage'));
const CheckPage = React.lazy(() => import('../containers/checkPage/CheckPage'));
const PayResultPage = React.lazy(() => import('../containers/payResultPage/PayResultPage'));
const ProfilePage = React.lazy(() => import('../containers/profilePage/ProfilePage'));
const OrderInfoPage = React.lazy(() => import('../containers/orderInfoPage/OrderInfoPage'));
const AboutPage = React.lazy(() => import('../containers/aboutPage/AboutPage'));
const DeliveryInfoPage = React.lazy(() => import('../containers/deliveryInfoPage/DeliveryInfoPage'));
const KitchensPage = React.lazy(() => import('../containers/kitchensPage/KitchensPage'));
const CouriersPage = React.lazy(() => import('../containers/couriersPage/CouriersPage'));
const OrganizationPage = React.lazy(() => import('../containers/organizationsPage/OrganizationPage'));
const PricePage = React.lazy(() => import('../containers/pricePage/PricePage'));
const TestdrivePage = React.lazy(() => import('../containers/testdrivePage/TestdrivePage'));
const InteractiveMapPromoModule = React.lazy(() => import('../interactiveMapPromoModule/InteractiveMapPromoModule'));
const InteractiveMapPromoModuleForLink = React.lazy(() => import('../interactiveMapPromoModuleForLink/InteractiveMapPromoModuleForLink'));
const NotFoundPage = React.lazy(() => import('../containers/notFoundPage/NotFoundPage'));

export const SitiyRouter = () => {
    const { isAuth } = useSelector(state => state.profile);

    return (
        <Suspense fallback={<></>}>
            <Routes>
                <Route path="/" element={<MainPage/>}/>
                <Route path="/menu/:id" element={<MenuPage/>}/>
                <Route path="/cart" element={isAuth ? <CartPage/> : <Navigate to="/"/>}/>
                <Route path="/check" element={isAuth ? <CheckPage/> : <Navigate to="/"/>}/>
                <Route path="/pages/PayResult" element={isAuth ? <PayResultPage/> : <Navigate to="/"/>}/>
                <Route path="/profile" element={isAuth ? <ProfilePage/> : <Navigate to="/"/>}/>
                <Route path="/profile/:tab" element={isAuth ? <ProfilePage/> : <Navigate to="/"/>}/>
                <Route path="/orderinfo/:id" element={<OrderInfoPage/>}/>
                <Route path="/about" element={<AboutPage/>}/>
                <Route path="/delivery" element={<DeliveryInfoPage/>}/>
                <Route path="/kitchens" element={<KitchensPage/>}/>
                <Route path="/kitchens/:tab" element={<KitchensPage/>}/>
                <Route path="/courier" element={<CouriersPage/>}/>
                <Route path="/courier/:tab" element={<CouriersPage/>}/>
                <Route path="/organizations" element={<OrganizationPage/>}/>
                <Route path="/app" element={<InteractiveMapPromoModule/>}/>
                <Route path="/link" element={<InteractiveMapPromoModuleForLink/>}/>
                <Route path="/price" element={<PricePage/>}/>
                <Route path="/testdrive" element={<TestdrivePage/>}/>
                <Route path="*" element={<NotFoundPage/>}/>
            </Routes>
        </Suspense>
    );
};

export const PartnerRouter = () => {
    const { isAuth } = useSelector(state => state.profile);

    return (
        <Suspense fallback={<></>}>
            <Routes>
                <Route path="/" element={<MenuPage/>}/>
                <Route path="/cart" element={isAuth ? <CartPage/> : <Navigate to="/"/>}/>
                <Route path="/check" element={isAuth ? <CheckPage/> : <Navigate to="/"/>}/>
                <Route path="/pages/PayResult" element={<PayResultPage/>}/>
                <Route path="/profile" element={isAuth ? <ProfilePage/> : <Navigate to="/"/>}/>
                <Route path="/profile/:tab" element={isAuth ? <ProfilePage/> : <Navigate to="/"/>}/>
                <Route path="/about" element={<AboutPage/>}/>
                <Route path="/delivery" element={<DeliveryInfoPage/>}/>
                <Route path="*" element={<NotFoundPage/>}/>
            </Routes>
        </Suspense>
    );
};
